// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","priceTooltip":"_2PgAuW41rsK_24prBHzrzt"};